import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from './Constants.js';
import { Spinner } from 'react-bootstrap';

const Return_Stock = () => {
  const [stocks, setStocks] = useState([]);
  const [sizesMap, setSizesMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [formError, setFormError] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    fetch(`${BASE_URL}get_return_id/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(async data => {
        if (data?.status && Array.isArray(data.data)) {
          const enrichedStocks = await Promise.all(
            data.data.map(async (record, index) => {
              const sizes = await fetchSizesByType(record.dress_type_id, token);
              setSizesMap(prev => ({ ...prev, [index]: sizes }));
              return {
                ...record,
                existing_dress_size: record.dress_size_id || '',
                dress_size: ''
              };
            })
          );
          setStocks(enrichedStocks);

        }
      })
      .catch(err => console.error('Stock fetch error:', err))
      .finally(() => setLoading(false));
  }, [id]);

  const fetchSizesByType = async (typeId, token) => {
    try {
      const res = await fetch(`${BASE_URL}dress_sizes_by_type`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ type_id: typeId }),
      });
      const data = await res.json();
      return data.dressTypes || [];
    } catch (err) {
      console.error(`Size fetch error for type ${typeId}:`, err);
      return [];
    }
  };

  const handleSizeChange = async (index, selectedSizeId) => {
    if (!selectedSizeId) return;

    try {
      const token = localStorage.getItem('authToken');
      const typeId = stocks[index].dress_type_id;
      const gender = stocks[index].gender;
      const area = stocks[index].area_id;

      const colorRes = await fetch(`${BASE_URL}getNewDressColorId`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          size_id: selectedSizeId,
          type_id: typeId,
          gender: gender,
          area_id: area,
        }),
      });

      const colorData = await colorRes.json();

      // Safely extract color ID and quantity from response
      const newColorId = colorData?.data?.id?.[0]?.id || '';
      const newQuantity = colorData?.data?.qty?.[0]?.quantity || '';

      const updatedStocks = [...stocks];
      updatedStocks[index] = {
        ...updatedStocks[index],
        dress_size: selectedSizeId,
        new_dress_color_id: newColorId,
        new_quantity: newQuantity, // optional: only if you need it
      };

      setStocks(updatedStocks);
      setFormError(null);
    } catch (error) {
      console.error('Error fetching new dress color ID:', error);
      setFormError('Failed to fetch updated dress color.');
    }
  };





  const handleSubmit = async (index) => {
    const item = stocks[index];
    if (!item.dress_size) {
      setFormError('Please select a new dress size.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const payload = {
  stock_id: item.id,

  candidate_name: item.candidate_name,
  mobile: item.mobile,
  date_of_join: item.date_of_join,
  department: item.department,
  location: item.area,

  gender: item.gender,

  dress_type: item.dress_type,
  dresstype_id: item.dress_type_id,

  dress_color: item.dress_color,
  dresscolor_id: item.dress_color_id,

  uniform_qty: item.uniform_qty,

  area: item.area,
  area_id: item.area_id,

  dress_size: item.existing_dress_size,
  dresssize_id: item.existing_dress_size,

  new_dress_size: item.dress_size,
  new_dresssize_id: item.dress_size,

  new_dresscolor_id:
    item.dress_type?.toLowerCase() === "apron"
      ? ""
      : item.new_dress_color_id,

  avl_qty:
    item.dress_type?.toLowerCase() === "apron"
      ? ""
      : item.new_quantity,

  approval_status: "Pending",
  created_by: localStorage.getItem("emp_code") || ""
};

      const response = await fetch(`${BASE_URL}return_stock_insert`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result.status) {
        navigate('/manage_employee');
      } else {
        setFormError('Failed to update stock.');
      }
    } catch (error) {
      console.error(error);
      setFormError('Error updating stock.');
    }
  };

  const handleBackClick = () => navigate('/manage_employee');
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

  if (loading) {
    return <div className="text-center mt-5"><Spinner animation="border" variant="primary" /></div>;
  }

  return (
    <div className="page-wrapper" style={{ height: '100vh', overflow: 'hidden' }}>
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container" style={{
        marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
        transition: 'margin-left 0.3s ease',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}>
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content flex-grow-1" style={{ overflow: 'auto' }}>
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="col-lg-12">
                <div className="card shadow-sm border-0">
                  <div className="card-header bg-white">
                    <h4 className="mb-0 text-primary">Return Stock</h4>
                  </div>
                  <div className="card-body">
                    {formError && <div className="alert alert-danger small">{formError}</div>}

                    <div className="row">
                      {stocks.map((stock, index) => (
                        <div className="col-md-6 mb-4" key={index}>
                          <form
                            onSubmit={(e) => { e.preventDefault(); handleSubmit(index); }}
                            className="d-flex flex-column h-100 border rounded bg-light shadow-sm p-3"
                            style={{ minHeight: '500px', fontSize: '0.875rem' }}
                          >
                            {/* Scrollable content */}
                            <div className="flex-grow-1 overflow-auto pe-1">
                              <h6 className="text-secondary mb-3">#{index + 1} - {stock.dress_type}</h6>

                              {[['Candidate Name', stock.candidate_name],
                              ['Mobile', stock.mobile],
                              ['Date of Join', stock.date_of_join],
                              ['Department', stock.department],
                              ['Location', stock.area],
                              ['Gender', stock.gender],
                              ['Dress Type', stock.dress_type],
                              ['Dress Type Id', stock.dress_type_id],
                              ['Dress Color', stock.dress_color],
                              ['Dress Color Id', stock.dress_color_id],
                              ['Uniform Qty', stock.uniform_qty],
                              ['Area', stock.area],
                              ['Dress Size Id', stock.dress_size_id],
                              ].map(([label, value], i) => (
                                <div className="form-group mb-2" key={i}>
                                  <label className="form-label small mb-1">{label}</label>
                                  <input type="text" className="form-control form-control-sm" value={value} readOnly />
                                </div>
                              ))}

                              <div className="form-group mb-2">
                                <label className="form-label small mb-1">Existing Size</label>
                                <select className="form-control form-control-sm" value={stock.existing_dress_size} disabled>
                                  <option value="">Select Size</option>
                                  {(sizesMap[index] || []).map(size => (
                                    <option key={size.id} value={size.id}>{size.dress_size}</option>
                                  ))}
                                </select>
                              </div>

                              <div className="form-group mb-3">
                                <label className="form-label small mb-1">New Dress Size</label>
                                <select
                                  className="form-control form-control-sm"
                                  name="dress_size"
                                  value={stock.dress_size}
                                  onChange={(e) => handleSizeChange(index, e.target.value)}
                                >
                                  <option value="">Select Size</option>
                                  {(sizesMap[index] || []).map(size => (
                                    <option key={size.id} value={size.id}>{size.dress_size}</option>
                                  ))}
                                </select>
                              </div>

                              {/* New fields to display selected size and new dress color */}
                              <div className="form-group mb-2">
                                <label className="form-label small mb-1">Selected New Dress Size ID</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={stock.dress_size || ''}
                                  readOnly
                                />
                              </div>

                              {stock.dress_type?.toLowerCase() !== "apron" && (
                                <>
                                  <div className="form-group mb-2">
                                    <label className="form-label small mb-1">New Dress Color ID</label>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={stock.new_dress_color_id || ""}
                                      readOnly
                                    />
                                  </div>

                                  <div className="form-group mb-2">
                                    <label className="form-label small mb-1">Available Quantity</label>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={stock.new_quantity || ""}
                                      readOnly
                                    />
                                  </div>
                                </>
                              )}
                            </div>

                            {/* Sticky action buttons */}
                            <div className="mt-3 d-flex justify-content-between border-top pt-2">
                              <button type="submit" className="btn btn-sm btn-primary px-3">Submit</button>
                              <button type="button" className="btn btn-sm btn-secondary px-3" onClick={handleBackClick}>Cancel</button>
                            </div>
                          </form>
                        </div>

                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Return_Stock;
